var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0794 3.38951C11.2353 3.53226 11.323 3.72586 11.323 3.92771C11.323 4.12957 11.2353 4.32316 11.0794 4.46591L6.67516 8.4952L11.0794 12.5245C11.1588 12.5947 11.2222 12.6787 11.2658 12.7716C11.3094 12.8645 11.3324 12.9644 11.3333 13.0654C11.3343 13.1665 11.3132 13.2667 11.2714 13.3603C11.2296 13.4539 11.1678 13.5389 11.0897 13.6103C11.0115 13.6818 10.9186 13.7383 10.8164 13.7766C10.7141 13.8149 10.6045 13.8341 10.4941 13.8333C10.3836 13.8324 10.2744 13.8114 10.1729 13.7715C10.0714 13.7316 9.97955 13.6736 9.90279 13.6009L4.91033 9.0334C4.75434 8.89065 4.66671 8.69706 4.66671 8.4952C4.66671 8.29335 4.75434 8.09975 4.91033 7.957L9.90279 3.38951C10.0588 3.2468 10.2704 3.16663 10.4911 3.16663C10.7117 3.16663 10.9233 3.2468 11.0794 3.38951Z",
    fill: "#1D314C",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.e20933d7e05f3a100f485d71cc95db50.svg";
export { ForwardRef as ReactComponent };